export { default } from '@relo/sports-components/es/Card';
export * from '@relo/sports-components/es/Card';
